import { render, staticRenderFns } from "./AffiliateClientList.vue?vue&type=template&id=800a51e6&"
import script from "./AffiliateClientList.vue?vue&type=script&lang=js&"
export * from "./AffiliateClientList.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateClientList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports